"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = require("@/api/education/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      formInline: {
        id: this.$route.query.id,
        name: "",
        uniqueCode: "",
        cityId: "",
        isLock: ""
      },
      rules: {
        name: [{
          required: true,
          message: "请输入教育局名称",
          trigger: "blur"
        }, {
          min: 2,
          max: 30,
          message: "长度在 2 到 30 个字符",
          trigger: "blur"
        }],
        uniqueCode: [{
          required: true,
          message: "请输入教育局编码",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    // 根据id获取教育局信息
    getInfo: function getInfo() {
      var _this = this;
      (0, _index.getEducationInfoById)({
        id: this.$route.query.id
      }).then(function (res) {
        var data = res.data;
        _this.formInline = data;
      });
    },
    onSubmit: function onSubmit(rulesForm) {
      var _this2 = this;
      this.$refs[rulesForm].validate(function (valid) {
        if (valid) {
          (0, _index.educationEdit)(_this2.formInline).then(function (res) {
            if (res.code === 2000) {
              _this2.$message.success("操作成功");
              _this2.$router.push("/schoolTest/educationList");
            }
          }).catch(function (e) {
            console.log(e);
          });
        } else {
          _this2.$message.error("保存失败,请检查填写信息。");
          return false;
        }
      });
    },
    isBack: function isBack() {
      history.go(-1);
    }
  },
  created: function created() {
    this.getInfo();
  }
};